import {post, get} from "@/utils/request";


export default {
    login: (data) => {
        return post('auth/login', data);
    },
    getVerifyCode: () => {
        return get('/getVerifyCode');
    },
    getVerifyCodeContent: (inputVerifyCode) => {
        return get('/getVerifyCodeContent', {'inputVerifyCode': inputVerifyCode});
    },
    logout: () => {
        return post('auth/logout');
    }
}